import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/site/Layout";
import ScrollToTop from "@/components/site/ScrollToTop";
import HomePage from "@/pages/HomePage";
import HealthPage from "@/pages/HealthPage";
import FinancePage from "@/pages/FinancePage";
import AboutPage from "@/pages/AboutPage";
import BlogListPage from "@/pages/BlogListPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ContactPage from "@/pages/ContactPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/gesundheit" element={<HealthPage />} />
          <Route path="/finanzen" element={<FinancePage />} />
          <Route path="/ueber-mich" element={<AboutPage />} />
          <Route path="/beitraege" element={<BlogListPage />} />
          <Route path="/beitraege/:slug" element={<BlogPostPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
